export const FormCaption = (props) => {
    return (
        <div className="form-caption">
            {props.caption}
        </div>
    )
}